import React from 'react';
import { createRoot } from 'react-dom/client';

import SearchContainer from './components/SearchContainer';
import { SearchContextProvider } from './search/SearchContextProvider';
import config from './config.json';
import { initFallbackCollectionListener } from './searchHelpers';
import createConfig from './searchConfig';

import '../css/main.scss';

export function init() {
  const rubricSearchRoot = document.getElementById('rubric-search');
  const configName = rubricSearchRoot.dataset.configName;
  if (Object.keys(config).indexOf(configName) === -1) {
    // without valid key search won't setup
    // eslint-disable-next-line no-console
    console.error('Search: config-name is invalid.');
    return;
  }
  const algoliaIndex = rubricSearchRoot.dataset.algoliaIndex;
  const algoliaDomainIndex = rubricSearchRoot.dataset.algoliaDomainIndex;
  const fallbackCollectionId = rubricSearchRoot.dataset.fallbackCollectionId;
  const isWebview = rubricSearchRoot.dataset.isWebview === '1';
  const defaultPortalName = document.querySelector(
    'meta[name="srf:portal:name"]',
  ).content; // portal helper won't work with ESI so fall back to meta tag
  const businessUnit = document.getElementsByTagName('body')[0].dataset.bu;
  const searchConfig = createConfig(
    config,
    configName,
    defaultPortalName,
    businessUnit,
  );
  initFallbackCollectionListener(fallbackCollectionId);
  const root = createRoot(rubricSearchRoot);
  root.render(
    <SearchContextProvider
      searchConfig={searchConfig}
      translationSource=".srf-rubric-search">
      <SearchContainer
        isWebview={isWebview}
        algoliaIndex={algoliaIndex}
        algoliaDomainIndex={algoliaDomainIndex}
      />
    </SearchContextProvider>,
  );
}
